import * as React from 'react'
import { ReactElement, useMemo } from 'react'
import BaseFileOverview, { FileFilterType } from '../../../../pages/File/BaseFileOverview'
import { ViewCRMProps } from '../ViewCRM'

export default function CRMFileOverview(props: ViewCRMProps): ReactElement {
    const fixedFilterValues = useMemo<FileFilterType>(
        () => ({
            crmRelations: [props.crmRelationId],
        }),
        [props.crmRelationId],
    )

    return <BaseFileOverview fixedFilterValues={fixedFilterValues} localStorageKeyPrefix={`HammockCRMFileOverview-${props.crmRelationId}`} />
}
